import React from 'react'
import PropTypes from 'prop-types'

// @material-ui
import {
  Box,
  Icon,
  Card,
  CardHeader,
  CardContent,
  Typography,
} from '@material-ui/core'
import { withStyles } from '@material-ui/styles'

// core
import { withLang } from '_core/hocs/withLang'
import { PriceMix } from '_core/components/PriceMix'

// style
import { ownGoodsItemStyle } from './ownGoodsItemStyle'

const RawOwnGoodsItem = props => {
  const { classes, data, getLangString: l } = props

  return (
    <Card className={classes.ownCard}>
      <CardHeader
        className={classes.header}
        disableTypography={true}
        title={<Typography variant="body1">{data.title}</Typography>}
        subheader={
          <Typography variant="body2">
            <Icon className={classes.timeIcon}>access_time</Icon>
            {data.payment?.time?.format}
          </Typography>
        }
      />

      <CardContent>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          className={classes.fullHeight}
        >
          <Typography variant="caption" color="textSecondary">
            {l('r.summa.investiciy')}
          </Typography>

          <PriceMix
            rootProps={{ variant: 'h6', color: 'primary' }}
            item={{
              value: data.amount.value * data.count,
              currency: data.amount.currency.id,
            }}
          />
        </Box>
      </CardContent>
    </Card>
  )
}

RawOwnGoodsItem.defaultProps = {}

RawOwnGoodsItem.propTypes = {
  // self props
  data: PropTypes.object.isRequired,

  // `withStyles` HOC props
  classes: PropTypes.object.isRequired,

  // `withLang` HOC props
  langInfo: PropTypes.object,
  langStrings: PropTypes.object,
  getLangObject: PropTypes.func,
  getFirstLangString: PropTypes.func,
  getLangStringSet: PropTypes.func,
  getLangString: PropTypes.func.isRequired,
}

export const OwnGoodsItem = withLang(
  withStyles(ownGoodsItemStyle)(RawOwnGoodsItem)
)
